'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'

// walrus
import Box from '@components/kit/box'
import { HeaderBackButton } from '@components/kit/header'
import { useNavigate } from 'react-router-dom'
import AppShell from '@components/ui/app-shell'
import PageHeader from '@components/ui/page-header'
import { useOpportunityStore } from '@store/Opportunity'
import MatchingMembers from './matching-members.web'

function Category() {
  const navigate = useNavigate()

  const { categoryId } = useParams()
  const [category, setCategory] = useState(null)
  const [isError, setIsError] = useState(false)
  const { fetchOpportunityCategories, findOpportunityCategoryById } =
    useOpportunityStore.getState()

  useEffect(() => {
    if (!category && !isError) {
      const categoryFound = findOpportunityCategoryById(parseInt(categoryId))
      if (categoryFound) {
        setCategory(categoryFound)
      } else {
        fetchOpportunityCategories()
          .then(success => {
            if (!success) {
              setIsError(true)
              setTimeout(() => {
                setIsError(false)
              }, 2000)
              return
            }
            const categoryFound = findOpportunityCategoryById(
              parseInt(categoryId)
            )
            if (categoryFound) {
              setCategory(categoryFound)
            } else {
              setIsError(true)
            }
          })
          .catch(() => {
            setIsError(true)
            setTimeout(() => {
              setIsError(false)
            }, 2000)
          })
      }
    }
  }, [])

  return (
    <AppShell activePage='opportunities' label='Opportunities Category'>
      <Box alignItems='center' flexDirection='row' mb='08'>
        <HeaderBackButton
          accessibilityHint='Go back to the previous screen'
          accessibilityLabel='Back'
          accessibilityRole='button'
          ml='-12'
          onPress={() => {
            navigate('/opportunities')
          }}
        />
      </Box>

      <PageHeader
        eyebrow='Opportunities'
        title={isError ? 'Error: Category not found' : category?.title ?? ''}
      />

      <MatchingMembers categoryId={parseInt(categoryId)} />
    </AppShell>
  )
}

export default Category
